import "./App.css";

function App(props) {
  const { childComp } = props;
  return <div className="App">{childComp}</div>;
}

export default App;
